import { createRoot } from 'react-dom/client';
import { SearchApp } from './SearchApp';

export const initializeSearchApp = () => {
    const searchContainer = document.getElementById('react-search-app');
    
    if (searchContainer) {
        const root = createRoot(searchContainer);
        
        // Get configuration from data attributes
        const apiUrl = searchContainer.dataset.apiUrl || '/umbraco/api/SearchApi/Search';
        const autocompleteApiUrl = searchContainer.dataset.autocompleteApiUrl || '/umbraco/api/SearchApi/Autocomplete';
        const placeholder = searchContainer.dataset.placeholder || 'Search NACUFS...';
        const buttonText = searchContainer.dataset.buttonText || 'Search';
        const debounceMs = parseInt(searchContainer.dataset.debounceMs || '300', 10);
        
        // Get initial query from URL
        const urlParams = new URLSearchParams(window.location.search);
        const initialQuery = urlParams.get('query') || '';
        
        root.render(
            <SearchApp
                apiUrl={apiUrl}
                autocompleteApiUrl={autocompleteApiUrl}
                initialQuery={initialQuery}
                placeholder={placeholder}
                buttonText={buttonText}
                debounceMs={debounceMs}
            />
        );
    }
};

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSearchApp);
} else {
    initializeSearchApp();
}
